// src/utils/qrThemeApi.js
//
// The look of a facility's QR pages (backend routes/qrTheme.ts, owner only):
// the « Afficher le QR » page's style (layout) and language (null = from the
// facility's country), a background colour and a font, from the backend's lists.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const BASE = `${API_BASE_URL}/v2/qr-theme`;

async function call(method, facilityId, token, body) {
  const r = await fetch(`${BASE}/${facilityId}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(data.error || `HTTP_${r.status}`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const getQrTheme = (facilityId, token) => call('GET', facilityId, token);
export const saveQrTheme = (facilityId, color, font, layout, language, token) =>
  call('PUT', facilityId, token, { color, font, layout, language });
